import type { DeviceModel } from '../../types/deviceModel';
import { portRow, simpleLayout } from './layoutHelpers';

function unifiAp(equipmentId: string, watts: number, at: boolean): DeviceModel {
  return {
    equipmentId,
    selfDrawWatts: watts,
    powerInputs: [{ id: 'poe-in', kind: 'poe-in', portNumber: 1, face: 'front' }],
    layout: {
      simple: simpleLayout(
        portRow({
          count: 1,
          startNumber: 1,
          kind: 'rj45',
          speedsMbps: [10, 100, 1000],
          poeIn: {
            standards: at ? ['802.3af', '802.3at'] : ['802.3af'],
            voltageMin: 37,
            voltageMax: 57,
            maxWatts: watts,
          },
          y: 22,
        }),
        160,
        70
      ),
    },
  };
}

export const u6LiteModel = unifiAp('ubnt-u6-lite', 12, false);
export const u6LrModel = unifiAp('ubnt-u6-lr', 16.5, true);
export const u6ProModel = unifiAp('ubnt-u6-pro', 16, true);
